export default "__VITE_ASSET__BURddyeC__"